import TerminalMatchAction from './terminalMatchAction'
import ProductMatchAction from './productMatchAction'
import CheckSaleDataAction from './saleDataDetail'
import ApplyRinseRule from './applyRinseRule';

export default [ TerminalMatchAction ,ProductMatchAction,CheckSaleDataAction, ApplyRinseRule ]